import React from 'react';
import styled from 'styled-components';
import { primaryColor } from '../../utils/styles';
import { Section } from './';

export const FOOTER_HEIGHT = '60px';

const StyledFooter = styled.footer`
  height: ${FOOTER_HEIGHT};
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

const TwitterLink = styled.a`
  font-weight: 700;
  color: ${primaryColor};
  &:hover {
    color: ${primaryColor};
  }
`;
const FooterLeft = styled.div`
  display: flex;
  flex-direction: column;
`;

const FooterRight = styled.div``;

const ProductHuntLink = styled.a`
  display: flex;
`;
const ProductHuntImg = styled.img`
  margin: 0;
  height: 34px;
`;

export const Footer = () => (
  <Section>
    <StyledFooter>
      <FooterLeft>
        <TwitterLink href="https://twitter.com/bestpeopleat">@bestpeopleat</TwitterLink>
      </FooterLeft>
      <FooterRight>
        <ProductHuntLink
          href="https://www.producthunt.com/posts/work-from-home-gear?utm_source=badge-featured&utm_medium=badge&utm_souce=badge-work-from-home-gear"
          target="_blank"
        >
          <ProductHuntImg
            src="https://api.producthunt.com/widgets/embed-image/v1/featured.svg?post_id=276204&theme=light"
            alt="Work From Home Gear - Everything you need to work productively. | Product Hunt"
          />
        </ProductHuntLink>
      </FooterRight>
    </StyledFooter>
  </Section>
);
